// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2oP-H","notes":"Notes_notes__2sK7-"};